import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthenticationConfiguration } from "./Configuration";
import useAuthenticationStore from "./Store";
import VerifyMfa from "./VerifyMfa";
import { AuthenticationViews } from "./types";

const VerifyMfaContainer: React.FC = () => {
    const configuration = useAuthenticationConfiguration();
    const { state, getClientVerificationToken, verifyMfa, hasPasskey, verifyPasskey, setRememberMe } =
        useAuthenticationStore();
    const navigate = useNavigate();
    const { serverError, isLoading, rememberMe, isTotpEnabled } = state;
    const [passkeyEnabled, setPasskeyEnabled] = useState<boolean | undefined>(undefined);

    useEffect(() => {
        if (!configuration.hasMfaConfig) {
            navigate("../" + AuthenticationViews.login);
        }
    }, [configuration.hasMfaConfig, navigate]);

    useEffect(() => {
        if (configuration.passkeyServerBaseUrl) {
            const checkForPasskey = async () => {
                if (configuration.passkeyServerBaseUrl) {
                    const options = await hasPasskey();
                    setPasskeyEnabled(!!(options?.allowCredentials?.length));
                }
            };
            checkForPasskey();
        }
        else {
            setPasskeyEnabled(false);
        }
    }, []);

    return (
        <VerifyMfa
            serverError={serverError}
            isLoading={isLoading}
            allowRememberMe={configuration.totpAllowRememberMe}
            rememberMe={rememberMe}
            rememberMeDays={
                configuration.totpRememberMeHours ? Math.round(configuration.totpRememberMeHours / 24) : undefined
            }
            verifyMfa={verifyMfa}
            passkeyEnabled={passkeyEnabled}
            verifyPasskey={passkeyEnabled ? verifyPasskey : undefined}
            setRememberMe={setRememberMe}
            isTotpEnabled={isTotpEnabled ?? false}
            hasRecoveryCodes={configuration.hasRecoveryCodes}
            getClientVerificationToken={getClientVerificationToken}
        />
    );
};

export default VerifyMfaContainer;
